import React from "react";
import {Field, reduxForm} from "redux-form";
import {Input} from "../../../../Utilits/Fields";
import {FieldIsRequared} from "../../../../Utilits/Validate";
import ProfileStatus from "../ProfileAboutMeStatus/ProfileStatus";
import saveProfile from "../../../../img/profileImg/saveProfile.png"
const EditModeProfileData = (props) => {
    return(
            <form onSubmit={props.handleSubmit} className="profile__lists-about-profile profile__margin">

                <button className="profile__button-edit-profile"><img src={saveProfile} alt=""/></button>

                <div className="profile__list-about-profile">
                    <p className='main-text'>Имя: </p>
                    <div className="additional-text input-style1 profile__input-style1"><Field name='fullName' component={Input} validate={[FieldIsRequared]} placeholder="Введите ваше имя"/></div>
                </div>
                <div className="profile__list-about-profile">
                    <p className='main-text'>Обо мне: </p>
                    <div className="additional-text input-style1 profile__input-style1"><Field name='aboutMe' component={Input} validate={[FieldIsRequared]} placeholder="Введите информацию"/></div>
                </div>
                <div className="profile__list-about-profile">
                    <p className='main-text'>Работа: </p>
                    <div className="additional-text input-style1 profile__input-style1"><Field name='lookingForAJobDescription' component={Input} validate={[FieldIsRequared]} placeholder="Введите информацию"/></div>
                </div>
                <div className="profile__list-about-profile">
                    <p className='main-text'>Cтатус: </p>
                    <div className="additional-text input-style1 profile__input-style1"><ProfileStatus status={props.status} putStatus={props.putStatus}/></div>
                </div>
            </form>
    )
};

export default reduxForm({form: "profile"})(EditModeProfileData)